import { Dispatch } from '.'

export const changeTrackListExpanded = (data: { channelId: string; ids: string[] }) => (dispatch: Dispatch) => {
  dispatch({
    type: 'CHANGE_EXPANDED_TRACK_LIST',
    payload: data
  })
}
